import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { TextField } from "@mui/material";

import { getobj, postobj } from "../apicall/apicall";
import { buttonStyle, form_add2 } from "../style/style";
import { Switch } from "@mui/material";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

export default function AddDevice(props) {
  const [update_device, setupdate_device] = useState({
    customer_id: props.id,
    device_group: "",
    mac_address: "",
    imei_number: "",
    device_name: "",
    device_type: "",
    comments: "",
    billing_type_id: 0,
    free_period: 0,
    active_status: false,
  });
  const [device, setdevice] = useState();
  const [billingType, setBillingType] = useState([]);
  const [freePeriodType, setFreePeriodType] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const isAdmin = localStorage.getItem("role") === "ADMIN";

  useEffect(() => {
    let url = process.env.REACT_APP_ZEWA_URL + "user/billing-type/";
    const d = getobj(url);
    d.then(function (res) {
      setBillingType(res);
    });
  }, []);

  useEffect(() => {
    let url = process.env.REACT_APP_ZEWA_URL + "device/free-period-types/";
    const d = getobj(url);
    d.then(function (res) {
      setFreePeriodType(res);
    });
  }, []);

  const handleChange = (e) => {
    console.log(update_device);
    const { name, value } = e.target;
    const parsedValue = parseInt(value) || value;
    const selectedDevice = device.find((i) => i.id === parsedValue);

    if (selectedDevice) {
      setupdate_device({
        ...update_device,
        [name]: parsedValue,
        device_name: selectedDevice.device_name,
        device_type: selectedDevice.device_type,
      });
      // Clear error when valid selection is made
      if (errors.device_group) {
        setErrors({ ...errors, device_group: "" });
      }
    }
  };
  function validate(data) {
    let res = true;
    let value = Object.keys(data).map((i) => {
      if (i !== "comments" && data[i] === "") {
        return false;
      }
      return true;
    });
    for (let i = 0; i < value.length; i++) {
      res = res && value[i];
    }
    return res;
  }
  useEffect(() => {
    const url = process.env.REACT_APP_ZEWA_URL + "device/addDeviceGroup/";
    const d = getobj(url);
    d.then(function (res) {
      setdevice(res);
    });
  }, []);

  const handleChange2 = (e) => {
    const { name, value } = e.target;
    if (name === "active_status") {
      setupdate_device({
        ...update_device,
        active_status: e.target.checked,
      });
    } else if (name === "free_period" || name === "billing_type_id") {
      setupdate_device({
        ...update_device,
        [name]: parseInt(value) || 0,
      });
    } else {
      setupdate_device({
        ...update_device,
        [name]: value,
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate Model is selected
    if (!update_device.device_group || update_device.device_group === "") {
      newErrors.device_group = "Model is required";
    }

    if (
      update_device.device_type === "BLUETOOTH" &&
      !update_device.mac_address.trim()
    ) {
      newErrors.mac_address = "Bluetooth ID cannot be blank";
    } else if (
      update_device.device_type === "CELLULAR" &&
      !update_device.imei_number.trim()
    ) {
      newErrors.imei_number = "IMEI cannot be blank";
    }
    if (update_device.imei_number.trim().length > 15) {
      newErrors.imei_number =
        "IMEI can length can not be greater than 15 characters";
    } else if (update_device.mac_address.trim().length > 20) {
      newErrors.mac_address =
        "Bluetooth ID can length can not be greater than 20 characters";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    let { mac_address, imei_number } = update_device;
    let device = {
      ...update_device,
      mac_address: mac_address ? mac_address : "NA",
      imei_number: imei_number ? imei_number : "NA",
    };
    if (validate(device) && validateForm()) {
      const url = process.env.REACT_APP_ZEWA_URL + "device/add-device/";
      postobj(url, device).then(function (d) {
        if (d.status === 201) {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success(d.Message, "Success", 2000);
          props.setaddDevice(false);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);
          NotificationManager.error(d.Message, "Failed", 2000);
        }
      });
    } else {
      // Build error message from specific field errors
      console.log("Error Logs:", validateForm(), errors);
      const errorMessages = Object.values(errors).filter(Boolean).join(", ");
      const errorMessage =
        errorMessages || "Please fill all required fields correctly";

      // Show error notification when validation fails
      NotificationManager.error(errorMessage, "Validation Error", 2000);
    }
    setLoading(false);
  };

  return (
    <Box>
      <Box
        sx={{
          minWidth: "clamp(100px, 15vw, 120px)",
          marginTop: "0.625rem",
          padding: "1rem",
        }}
      >
        <form onSubmit={handleSubmit}>
          <FormControl fullWidth error={!!errors.device_group}>
            <InputLabel> Select Model *</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              value={update_device.device_group || ""}
              label="Select Model"
              name="device_group"
              sx={form_add2}
              onChange={handleChange}
              required
            >
              {device &&
                device.map((i) => {
                  return (
                    <MenuItem value={i.id} key={i.id}>
                      {i.model_number}
                    </MenuItem>
                  );
                })}
            </Select>
            {errors.device_group && (
              <div
                style={{
                  color: "#d32f2f",
                  fontSize: "0.75rem",
                  marginTop: "3px",
                  marginLeft: "14px",
                  marginBottom: "10px",
                }}
              >
                {errors.device_group}
              </div>
            )}

            <TextField
              disabled
              name="device_name"
              id="deviceName"
              variant="outlined"
              sx={form_add2}
              label="Device Group"
              value={update_device.device_name}
            ></TextField>

            <TextField
              disabled
              name="device_type"
              id="deviceName"
              variant="outlined"
              label="Device type"
              sx={form_add2}
              value={update_device.device_type}
            ></TextField>
            <TextField
              name="comments"
              variant="outlined"
              label="Comments"
              sx={form_add2}
              onChange={handleChange2}
            ></TextField>
            <TextField
              id="outlined-select"
              select
              label="Select Billing Type"
              sx={form_add2}
              name="billing_type_id"
              value={update_device.billing_type_id || ""}
              onChange={handleChange2}
              required
            >
              {billingType.map((type) => (
                <MenuItem key={type.id} value={type.id}>
                  {type.name}
                </MenuItem>
              ))}
            </TextField>
            {isAdmin && (
              <TextField
                id="outlined-select"
                select
                label="Select Free Period"
                sx={form_add2}
                name="free_period"
                value={update_device.free_period || ""}
                onChange={handleChange2}
                required
              >
                {freePeriodType.map((type) => (
                  <MenuItem key={type.id} value={type.id}>
                    {type.free_time_period} month
                  </MenuItem>
                ))}
              </TextField>
            )}

            {update_device.device_type === "BLUETOOTH" ? (
              <TextField
                error={!!errors.mac_address}
                value={update_device.mac_address}
                id="outlined-error-helper-text"
                label="Enter Buletooth ID"
                variant="outlined"
                name="mac_address"
                sx={form_add2}
                onChange={handleChange2}
                required
                helperText={errors.mac_address ? errors.mac_address : ""}
              />
            ) : (
              <TextField
                error={!!errors.imei_number}
                value={update_device.imei_number}
                id="outlined-error-helper-text"
                name="imei_number"
                variant="outlined"
                label="Enter IMEI"
                sx={form_add2}
                onChange={handleChange2}
                required
                helperText={errors.imei_number ? errors.imei_number : ""}
              ></TextField>
            )}

            <Box>
              Active Status:
              <Switch
                checked={update_device.active_status}
                onChange={handleChange2}
                name="active_status"
                inputProps={{ "aria-label": "controlled" }}
              />
            </Box>
            <Box m={-1}>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                className="form__custom-button"
                sx={buttonStyle}
                disabled={loading}
                // onClick={handleSubmit}
              >
                Add Device
              </Button>
              <Button
                color="error"
                variant="contained"
                className="form__custom-button"
                sx={buttonStyle}
                type="submit"
                onClick={() => {
                  props.setaddDevice(false);
                }}
              >
                cancel
              </Button>
            </Box>
          </FormControl>
        </form>
      </Box>
      <NotificationContainer />
    </Box>
  );
}
